import styles from './PublishBubble.module.scss'

const PublishBubble = ({ isPrevious, text }) => (
  <div className={styles.bubble}>
    <p className={styles.bubbleTitle}>
      {isPrevious ? 'Previous content' : 'New content'}
    </p>
    <p className={styles.bubbleText} style={{ opacity: isPrevious ? 0.6 : 1 }}>
      {text}
    </p>
  </div>
)

export default PublishBubble
